import { BaseBlock } from "./BaseBlock";
import { ProductHeaderBlock } from "./ProductHeaderBlock";
import { ProductStateBlock } from "./ProductStateBlock";
import { SubscriptionBlock } from "./SubscriptionBlock";
import { ProductActionsBlock } from "./ProductActionsBlock";
import type { AccountActions } from "../screens/components/AccountActions";

import type { Block } from "./Block";
import type {
    AppState
} from "../app/state/AppState";

type Product =
    NonNullable<
        AppState["accountData"]
    >["products"][number];

export class ProductAccountBlock
    extends BaseBlock {

    private readonly product: Product;

    private readonly blocks: Block[] = [];

    private readonly actions: AccountActions;

    private root!: HTMLElement;

    constructor(
            product: Product,
            actions: AccountActions
        ) {

            super();

            this.product = product;
            this.actions = actions;

        }

    public override mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "sticker-card account-card";

        this.blocks.length = 0;

        // -------------------------
        // Header
        // -------------------------

        this.blocks.push(

            new ProductHeaderBlock(
                this.product
            )

        );

        // -------------------------
        // State
        // -------------------------

        this.blocks.push(

            new ProductStateBlock(
                this.product
            )

        );

        // -------------------------
        // Subscriptions
        // -------------------------

        for (const subscription of this.product.subscriptions) {

            this.blocks.push(

                new SubscriptionBlock(
                    subscription,

                    this.actions
                )

            );

        }

        this.blocks.push(

            new ProductActionsBlock(
                this.product,
                this.actions
            )

        );

        // -------------------------
        // Mount
        // -------------------------

        for (const block of this.blocks) {

            block.mount();

            this.root.appendChild(
                block.getRoot()
            );

        }

    }

    public override update(): void {

        for (const block of this.blocks) {
            block.update();
        }

    }

    public override unmount(): void {

        for (const block of this.blocks) {
            block.unmount();
        }

        this.blocks.length = 0;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}